import { render, staticRenderFns } from "./mod3-3.vue?vue&type=template&id=2153249c&scoped=true&"
import script from "./mod3-3.vue?vue&type=script&lang=js&"
export * from "./mod3-3.vue?vue&type=script&lang=js&"
import style0 from "./mod3-3.vue?vue&type=style&index=0&id=2153249c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153249c",
  null
  
)

export default component.exports